import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { VariaveisCursorPayload } from '@shared/components/formula/variaveis-disponiveis-dialog/variaveis-disponiveis-dialog.component';
import { ObservacaoEditorComponent } from '@shared/components/formula/observacao-editor/observacao-editor.component';

/** Seção das informações adicionais ao fisco da regra (mesma composição da seção de informação ao fisco da aba ICMS da natureza). */
@Component({
    selector: 'app-regra-tributaria-informacao-fisco-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, ObservacaoEditorComponent],
    templateUrl: './regra-tributaria-informacao-fisco-section.component.html',
    styleUrl: './regra-tributaria-informacao-fisco-section.component.css',
})
export class RegraTributariaInformacaoFiscoSectionComponent {
    @Input({ required: true }) control!: FormControl;
    /** Variáveis do CST/cClassTrib selecionados; vazia desabilita o link do modal. */
    @Input() variaveis: VariavelStruct[] = [];
    @Input() isClassificacaoInformada = false;

    @Output() abrirVariaveis = new EventEmitter<VariaveisCursorPayload>();

    public onClicarVariaveis(editor: ObservacaoEditorComponent): void {
        if (this.variaveis.length === 0) return;
        this.abrirVariaveis.emit({ control: this.control, selectionStart: 0, selectionEnd: 0, editor });
    }
}
